import { EngagementSettingsRootPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/engagement/lib/SettingsCollectionsBootstrap'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { EmployeePulseConfig } from './EmployeePulseConfig'

const RootPage = () => {
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(EngagementSettingsRootPageDocument, {
    variables: { companyIds: company.id },
  })
  const settings = data?.engagement?.settings.at(0)

  return (
    <CollectionsBootstrap>
      <ResponsivePage.Body loading={loading || !settings} error={null} showHeader={false}>
        {settings && <EmployeePulseConfig settings={settings} advancedConfigurationEnabled />}
      </ResponsivePage.Body>
    </CollectionsBootstrap>
  )
}

export default RootPage
